var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "15px",
    viewBox: "0 0 20 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_check") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "md1025_desktop_SYI_errorstates",
    transform: "translate(-423.000000, -594.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_check",
    transform: "translate(423.257373, 591.250500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2827772,3.21604035 C19.5776772,3.50690535 19.5809772,3.98177535 19.2901272,4.27667535 L6.97788716,16.7591503 C6.83712716,16.9019503 6.64511216,16.9823503 6.44466716,16.9825012 C6.24422216,16.9828003 6.05204216,16.9027003 5.91101216,16.7602003 L0.217087163,11.0103403 C-0.0743778368,10.7160103 -0.0720528368,10.2411553 0.222277163,9.94969035 C0.516592163,9.65824035 0.991462163,9.66056535 1.28292716,9.95488035 L6.44286716,15.1655503 L18.2221272,3.22333035 C18.5129772,2.92843035 18.9878772,2.92516035 19.2827772,3.21604035 Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheck);
export default __webpack_public_path__ + "static/media/ic_check.c24eb3ad4c819129859ea711ffd1a890.svg";
export { ForwardRef as ReactComponent };